<script>
//--------------------------------------------------
// main script
//--------------------------------------------------
export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'team-player-events',

    //--------------------------------------------------
    // component props
    //--------------------------------------------------
	props: {
        /* The team name */
        teamName: String,
        playerEvents: Array,
        players: Array,
        isEvent: Boolean
	},

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: [
        'switch-tab'
    ],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            /* The show status for the popup model */
            isEventMode: true,
            isPlayerEventsExisted: false,
            isPlayersExisted: false
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        /**
         * @getter
         * Get the stater player list.
         */
        starterPlayers() {
            return this.mergePlayers(1)
        },
        /**
         * @getter
         * Get the bench player list.
         */
        benchPlayers() {
            return this.mergePlayers(2)
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        //--------------------------------------------------
        // handler method
        //--------------------------------------------------

        //--------------------------------------------------
        // private method
        //--------------------------------------------------
        /**
         * @private
         * Merge the event players and roster players according to the status.
         * @param status The roster status.
         * @return The merged players array.
         */
        mergePlayers(status) {
            const players = this.players || []
            const playerEvents = this.playerEvents || []
            let mergedPlayers = []
            for (let i = 0; i < players.length; i++) {
                let player = players[i]
                if (player.status === status) {
                    player.events = []
                    for (let j = 0; j < playerEvents.length; j++) {
                        let playerEvent = playerEvents[j]
                        if (Number(player.id) == Number(playerEvent.id)) {
                            player.events = playerEvent.events
                        }
                    }
                    mergedPlayers.push(player)
                }
            }
            return mergedPlayers
        }
    },

    //--------------------------------------------------
    // component watch
    //--------------------------------------------------
    watch: {
        /**
         * Watch the parent attribute to update the child property.
         */
        playerEvents(value) {
            if (value && value.length > 0) {
                this.isPlayerEventsExisted = true
            }
        },
        /**
         * Watch the parent attribute to update the child property.
         */
        players(value) {
            if (value && value.length > 0) {
                this.isPlayersExisted = true
            }
        },
        /**
         * Watch the parent attribute to update the child property.
         */
        isEvent(value) {
            this.isEventMode = value
        }
    },
    /**
     * @mounted
     * Update the isPlayerEventsExisted and isPlayersExisted after mounted.
     */
    mounted() {
        if (this.playerEvents && this.playerEvents.length > 0) {
            this.isPlayerEventsExisted = true
        }
        if (this.players && this.players.length > 0) {
            this.isPlayersExisted = true
        }
    }
}
</script>

<template>
    <!-- component -->
    <div class="team-player-events">
        <div class="head">
            <div class="team-label truncate">{{ teamName }}</div>
            <div class="switch-btn" @click="$emit('switch-tab')">
                切换球队
                <img class="right-arrow" src="@/assets/match-team-game/right-icon.svg"/>
            </div>
        </div>
        <div class="gap"></div>
        <div class="body">
            <div v-if="isEventMode" class="event-player-list">
                <div v-if="isPlayerEventsExisted" class="data-wrapper">
                    <div class="event-player-item" 
                        v-for="player in playerEvents" 
                        :key="player.id">
                        <div class="num-section">
                            <div class="num-wrapper">
                                <span v-if="player.number" class="label">{{ player.number }}</span>
                                <span v-else class="transparent">0</span>
                            </div>
                        </div>
                        <div class="name-section">
                            <div class="name-unit">
                                <span class="label">{{ player.name }}</span>
                            </div>
                            <div class="starter-unit">
                                <span v-if="player.isStarter" class="label">首发</span>
                                <span v-else class="label">替补</span>
                            </div>
                        </div>
                        <div class="event-section">
                            <div class="event-unit">
                                <div class="event-item" 
                                    v-for="event in player.events" 
                                    :key="event.id">
                                    <span class="icon">
                                        <span class="icon-holder" :class="event.type"></span>
                                    </span>
                                    <span class="minutes">{{event.time}}'</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="no-data-wrapper">
                    <img src="@/assets/match-team-game/no-data-symbol.svg"/>
                    <div class="label">暂无数据</div>
                </div>
            </div>
            <div v-else class="roster-player-list">
                <div v-if="isPlayersExisted" class="data-wrapper">
                    <div class="event-player-item starter-player-item" 
                        v-for="player in starterPlayers" 
                        :key="player.id">
                        <div class="num-section">
                            <div class="num-wrapper">
                                <span v-if="player.number" class="label">{{ player.number }}</span>
                                <span v-else class="transparent">0</span>
                            </div>
                        </div>
                        <div class="name-section">
                            <div class="name-unit">
                                <span class="label">{{ player.name }}</span>
                            </div>
                            <div class="starter-unit">
                                <span v-if="player.isStarter" class="label">首发</span>
                                <span v-else class="label">替补</span>
                            </div>
                        </div>
                        <div class="event-section">
                            <div class="event-unit">
                                <div class="event-item" 
                                    v-for="event in player.events" 
                                    :key="event.id">
                                    <span class="icon">
                                        <span class="icon-holder" :class="event.type"></span>
                                    </span>
                                    <span class="minutes">{{event.time}}'</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="gap"></div>
                    <div class="event-player-item bench-player-item" 
                        v-for="player in benchPlayers" 
                        :key="player.id">
                        <div class="num-section">
                            <div class="num-wrapper">
                                <span v-if="player.number" class="label">{{ player.number }}</span>
                                <span v-else class="transparent">0</span>
                            </div>
                        </div>
                        <div class="name-section">
                            <div class="name-unit">
                                <span class="label">{{ player.name }}</span>
                            </div>
                            <div class="starter-unit">
                                <span v-if="player.isStarter" class="label">首发</span>
                                <span v-else class="label">替补</span>
                            </div>
                        </div>
                        <div class="event-section">
                            <div class="event-unit">
                                <div class="event-item" 
                                    v-for="event in player.events" 
                                    :key="event.id">
                                    <span class="icon">
                                        <span class="icon-holder" :class="event.type"></span>
                                    </span>
                                    <span class="minutes">{{event.time}}'</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="no-data-wrapper">
                    <img src="@/assets/match-team-game/no-data-symbol.svg"/>
                    <div class="label">暂无数据</div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
.van-tabs__wrap {
    display: none;
}
</style>
<style scoped>
/**
 * Common
 */
.truncate {
	word-break: break-all;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.transparent {
    opacity: 0;
}
/**
 * @component
 */
.team-player-events {
    background: #F9F9F9;
}
/**
  * @head
  */
.head {
    padding: 12px 16px 8px 16px;
    position: relative;
    height: 20px;
    width: 345px;
    background: #FFFFFF;
    margin-bottom: 7px;
    /**
     * avoid the compatiable issue on the app
     * NOT: align-content: center;
     * BUT: line-height: 1;
     */
    line-height: 20px;
}
.team-label {
    display: inline-block;
    font-family: Source Han Sans;
    font-size: 16px;
    font-weight: bold;
    line-height: 16px;
    letter-spacing: normal;
    color: #3D3D3D;
    max-width: 250px;
}
.switch-btn {
    display: inline-block;
    position: absolute;
    right: 36px;
    margin-right: 2px;
    font-family: Source Han Sans;
    font-size: 14px;
    font-weight: 500;
    line-height: 14px;
    text-align: right;
    letter-spacing: 0.32px;
    color: #0FAC7F;
}
.right-arrow {
    position: absolute;
    top: -1.5px;
}
/**
 * @body
 */
.event-player-item {
    height: 60px;
    background: #FFFFFF;
    box-sizing: border-box;
    border-width: 0px 0px 1px 0px;
    border-style: solid;
    border-color: #E5E5E5;
}
.roster-player-list {
    margin-bottom: 15px;
}
.roster-player-list .gap {
    height: 7px;
}
.num-section {
    display: inline-block;
    padding: 20px 10px 20px 16px;  
}
.num-wrapper {
    text-align: center;
    width: 20px;
    height: 20px;
    border-radius: 3px;
    box-sizing: border-box;
    border: 1px solid #0FAC7F;
}
.num-wrapper .label {
    font-size: 14px;
    font-weight: bold;
    line-height: normal;
    letter-spacing: normal;
    color: #3D3D3D;
    display: flex;
    justify-content: center;
    align-items: center;
}
.name-section {
    display: inline-block;
    position: relative;
}
.name-unit {
    position: relative;
    top: 11px;
}
.name-unit .label {
    font-family: AlibabaPuHuiTi;
    font-size: 14px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #3D3D3D;
}
.starter-unit {
    position: relative;
    top: 16px;
    width: 29px;
    height: 14px;
    border-radius: 2px;
    background: #F0F0F3;
    border: 0.5px solid #979797;
    text-align: center;
}
.starter-unit .label {
    font-family: AlibabaPuHuiTi;
    font-size: 10px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #4D4D4D;
    position: relative;
    display: flex;
    justify-content: center;
}
.event-section {
    position: relative;
    text-align: right;
    float: right;
    right: 22px;
    display: flex;
    align-items: center;
    height: 100%;
}
.goal-unit,
.event-unit {
    max-width: 260px;
}
.event-unit .event-item {
    display: inline-block;
}
.goal-unit img {
    margin-right: 2px;
    width: 10px;
    height: 10px;
}
.event-item {
    margin-left: 6px;
}
.icon {
    display: inline-block;
    margin-right: 2px;
}
.icon-holder {
    width: 10px;
    height: 10px;
    display: inline-block;
    background-size: 10px 10px;
    background-repeat: no-repeat;
}
.icon-holder.goal {
    background-image: url('../../assets/match-team-game/goal-symbol.svg');
}
.icon-holder.own-goal {
    background-image: url('../../assets/match-team-game/own-goal-symbol.svg');
}
.icon-holder.penalty {
    background-image: url('../../assets/match-team-game/penalty-goal-symbol.svg');
}
.icon-holder.assist {
    background-image: url('../../assets/match-team-game/assist-symbol.svg');
}
.icon-holder.yellow {
    background-image: url('../../assets/match-team-game/yellow-card-symbol.svg');
}
.icon-holder.red {
    background-image: url('../../assets/match-team-game/red-card-symbol.svg');
}
.icon-holder.yellow-red {
    background-image: url('../../assets/match-team-game/yellow-red-card-symbol.svg');
}
.icon-holder.substitution-up {
    background-image: url('../../assets/match-team-game/substitution-up-symbol.svg');
}
.icon-holder.substitution-down {
    background-image: url('../../assets/match-team-game/substitution-down-symbol.svg');
}
.minutes {
    font-family: AlibabaPuHuiTi;
    font-size: 11px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #3D3D3D;
}
.no-data-wrapper {
    text-align: center;
    align-content: center;
    height: calc(100vh - 260px);
}
.no-data-wrapper .label {
    margin-top: 48px;
    font-family: AlibabaPuHuiTi;
    font-size: 15px;
    font-weight: normal;
    line-height: normal;
    text-align: center;
    letter-spacing: normal;
    color: #666666;
}
</style>